import { Pipe, PipeTransform } from '@angular/core';
import { isDeepEqual, areArraysEqual } from '@lx/shared/utils';
import { SortingCriteria } from '@lx/shared/types';

@Pipe({
  name: 'lxEqual',
  standalone: true,
})
export class EqualPipe implements PipeTransform {
  /**
   * Compare two objects or arrays of objects.
   *
   * Considerations:
   * - If you need to compare arrays that are not sorted, specify the sorting criteria to sort the arrays before comparison.
   * - If the objects are not arrays, the function will compare them directly.
   * - For comparing objects that deeply inside has arrays, if the arrays are not sorted the comparison will return false (this is because the function uses fast-deep-equal library that does not support deep comparison of arrays)
   *
   * @param originalObject the original object
   * @param objectToCompare the object to compare with
   * @param sortCriteria the sorting criteria in case of arrays (this is optional, just needed if you want to sort the arrays before comparison)
   */
  transform<T>(originalObject: T | T[], objectToCompare: T | T[], sortCriteria?: SortingCriteria<T>): boolean {
    // If objects to compare are arrays, call to specific function to compare arrays
    if (Array.isArray(originalObject) && Array.isArray(objectToCompare)) {
      return areArraysEqual(originalObject, objectToCompare, sortCriteria);
    }

    return isDeepEqual(originalObject, objectToCompare);
  }
}
